import { defineComponent, h } from 'vue';
import { QDialog } from 'quasar';
import EventBus from './event-bus.js';
import inputdialog from './components/vuecontrols/inputdialog.jsx';
import DialogBasicModal from './components/actions/DialogBasicModal.jsx';

export default defineComponent({
    name: 'DialogListener',
    components: {
        QDialog,
        DialogBasicModal
    },
    data: () => ({
        visible1: false,
        title: 'Test',
        body: 'More test',
        payload1: null,
        success: true,
        result: null,
    }),
    props: {},
    created() {
        console.log('dialog-listener waiting for SHOW_DIALOG');

        // "this" within the $on function does not refer to the Vue component. We must keep a reference separate.
        const dialog = this;

        EventBus.$on('SHOW_DIALOG', function (payLoad) {
            console.log('dialog-listener SHOW_DIALOG triggered');

            payLoad.componentOptions.propsData.okay = dialog.confirm;
            payLoad.componentOptions.propsData.cancel = dialog.cancel;

            dialog.payload1 = payLoad;
            dialog.visible1 = true;
        });

        EventBus.$on('DISPLAY_BASIC_MODAL', function (action, context) {
            console.log('dialog-listener DISPLAY_BASIC_MODAL triggered');

            dialog.payload1 = (
                <DialogBasicModal
                    root={context.root}
                    action={action}
                    context={context}>
                </DialogBasicModal>
            );
            dialog.visible1 = true;
        });

        EventBus.$on('CLOSE_DIALOG', function (success, result) {
            console.log('dialog-listener CLOSE_DIALOG triggered: success:' + (success ? 'true' : 'false') + ', result:' + JSON.stringify(result));
            dialog.success = success;
            dialog.result = result;
            dialog.visible1 = false;
        });
    },
    methods: {
        confirm() {
            this.visible1 = false;
        },
        cancel() {
            this.visible1 = false;
        }
    },
    render() {
        console.log('Rendering dialog... visible1: ' + this.visible1);

        return (
            <div class="c-DialogListener">
                <QDialog modelValue={this.visible1} onUpdate:modelValue={(v) => this.visible1 = v} persistent style="max-width: 600px; max-height: 600px;">
                    {this.payload1}
                </QDialog>
            </div>
        );
    }
});